export default "__VITE_ASSET__f93e114e__"